export default class {
    constructor(options){
        if(options){
            this.client = options.client
            this.organizationID = options.organizationID
        }
    }
    // mark ***
    fetch({organizationID}){
        throw new Error(`THIS ISN'T CORRECT`)
        //return this.client.get(`/organizations/${organizationID}`)
    }
    grant({organizationID}){
        return this.client.post('/accounts/grant', {organizationID})
    }
}


// WEBPACK FOOTER //
// ./lib/apiClient/organizations/accounts.js